export default {
  title: 'دليل المهنيين الصحيين',
  subtitle: 'قائمة المهنيين الصحيين المسجلين',
  search: 'البحث عن مهني',
  personnalInformations: 'المعلومات الشخصية',
  professionalInfoDisplay: {
    title: 'بطاقة معلومات المهني',
    generalInformations: 'معلومات عامة',
    professionnalInformations: 'معلومات مهنية',
    job: 'المهنة',
    expertise: 'الخبرة',
    speciality: 'التخصص',
    establishment: 'المؤسسة',
    coordinates: 'بيانات الاتصال',
    phone: 'الهاتف',
    mail: 'البريد الإلكتروني',
    location: 'العنوان',
    contact: 'اتصال'
  },
  columns: {
    professional: 'المهني',
    skills: 'المهارات',
    contact: 'الاتصال',
    actions: 'الإجراءات'
  },
  close: {
    filters: 'إغلاق الفلاتر',
    search: 'إغلاق البحث'
  },
  filters: {
    job: 'المهنة',
    skills: 'المهارات'
  },
  referent: 'المرجع',
  proReferent: 'المهني المُحيل',
  professionalList: {
    noEntry: 'لا يوجد مهنيون.',
    noSpecialty: 'لا يوجد تخصص',
    noProfession: 'لا توجد مهنة'
  },
  contact: {
    phone: 'الاتصال عبر الهاتف',
    mail: 'الاتصال عبر البريد الإلكتروني'
  },
  errors: {
    fetchProfessionals: 'خطأ أثناء استرجاع المهنيين',
    fetchBySearch: 'خطأ أثناء استرجاع المهنيين عن طريق البحث',
    fetchBySkills: 'خطأ أثناء استرجاع المهنيين حسب المهارات:',
    fetchByJob: 'خطأ أثناء استرجاع المهنيين حسب المهنة:',
    fetchSkills: 'خطأ أثناء استرجاع المهارات:'
  },
  professions: {
    dentalAssistant: 'مساعد طبيب أسنان',
    socialAssistant: 'مساعد اجتماعي',
    audioProsthetist: 'أخصائي تركيب السمعيات',
    chiropractor: 'مقوم العمود الفقري',
    dentalSurgeon: 'جراح أسنان',
    dietician: 'أخصائي تغذية',
    epithesist: 'أخصائي الأطراف الاصطناعية',
    ergotherapist: 'معالج مهني',
    nurse: 'ممرض',
    ermManipulator: 'فني أشعة',
    physiotherapist: 'أخصائي علاج طبيعي',
    doctor: 'طبيب',
    oculist: 'طبيب عيون',
    optician: 'أخصائي نظارات',
    speechTherapist: 'معالج النطق',
    orthopaedist: 'أخصائي تقويم العظام',
    orthoprosthetist: 'أخصائي الأطراف الاصطناعية والتقويم',
    orthotist: 'أخصائي تقويم العظام والجبائر',
    osteopath: 'معالج العظام',
    pharmacist: 'صيدلي',
    medicalPhysist: 'فيزيائي طبي',
    podiatrist: 'أخصائي الأقدام والأحذية الطبية',
    nonPS: 'مهنة غير صحية',
    psychologist: 'أخصائي نفسي',
    psychomotrician: 'معالج نفسي حركي',
    psychotherapist: 'معالج نفسي',
    chiropodist: 'أخصائي العناية بالقدم',
    midwife: 'قابلة',
    laboratoryTechnician: 'فني مختبر'
  }
}
